import { createSlice } from '@reduxjs/toolkit';

import { ADS } from '@perpay-web/fintech/constants/tableNames';
import { noop } from '@perpay-web/utils/noop';

const adsSlice = createSlice({
    name: 'ads',
    initialState: {},
    reducers: {
        fetchAds: noop,
        replaceAds: (state, action) => {
            const payload = Array.isArray(action.payload)
                ? Object.fromEntries(
                      action.payload.map((item, index) => [index, item]),
                  )
                : action.payload;
            return { ...payload };
        },
        fetchAdsError: noop,
    },
});

/**
 * @param {*} state
 * @returns {Array<{adType: BOX_AD_TYPE, amount: number, onClickCTA: () => void}>}
 */
export const getAds = (state) =>
    state.entities[ADS] ? Object.values(state.entities[ADS]) : [];

export const { fetchAds, replaceAds, fetchAdsError } = adsSlice.actions;
export default adsSlice.reducer;
